import { AppStateState, HomeStateState } from './types';

export const getHomeState = (state: AppStateState): HomeStateState =>
  state.homeState;

export default {
  getHomeState,
};
